import { FC } from 'react';
import {
    Button
} from '@mui/material';

export const ViewAccountInCoreButton: FC<{
    coreAccountId: string;
}> = ({ coreAccountId }) => {
    const coreAccountLink = process.env.REACT_APP_CORE_ACCOUNT_LINK;
    return (
        <Button
            className='view-in-core-button'
            variant="outlined"
            target="_blank"
            disabled={!coreAccountId}
            href={`${coreAccountLink}${coreAccountId}`}
        >
            View Account in Core
        </Button>
    )
};
